//@flow
import React from "react";

export default function percentFractionBarIndicator(params: {
  total: number,
  max: number,
  percent: number,
  count: number,
  threshold: number,
  showFractions: boolean,
  color: string,
  withoutWarningColor?: boolean,
}) {
  const {
    total,
    max,
    percent,
    count,
    showFractions,
    threshold,
    color,
    withoutWarningColor,
  } = params;
  const totalAsPercentileOfMax = max > 0 ? (100 / max) * total : 0;
  const col = color || "#ffddb4";
  return (
    <div
      style={{
        background: `linear-gradient(to right, ${col}, ${totalAsPercentileOfMax}%, transparent 1%)`,
      }}
      className="d-flex flex-column justify-content-center align-items-center w-100 h-100"
    >
      <div
        style={{
          lineHeight: "20px",
          color: percent >= threshold || withoutWarningColor ? "#charcoal" : "#d43f3a",
        }}
      >
        {percent}%
      </div>
      {showFractions ? (
        <div style={{ lineHeight: "20px", color: "#charcoala1" }}>{`(${total} / ${max})`}</div>
      ) : (
        ""
      )}
    </div>
  );
}
